import { contentfulApiThemeToContentThemeProps } from './contentfulApiThemeToContentThemeProps';
import React from 'react';
import { HomeProps } from '../views/Home/Home';
import { contentfulApiSectionToSectionProps } from './contentfulApiSectionToSectionProps';
import { SectionProps } from '../components/Section/Section';
import { ContentfulContentHubHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';
import { HeroBlockProps } from '@jbhi-fi/components/src/HeroBlock';
import { HeroTile } from '@jbhi-fi/components/src/HeroTile/HeroTile';
import { CardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CardTransformer';
import { HeroBlockTransformer } from '@jbhi-fi/components/src/Contentful/transformers/HeroBlockTransformer';
import { LaunchTilesTransformer } from '@jbhi-fi/components/src/Contentful/transformers/LaunchTilesTransformer';
import { ThemeTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';

export const contentfulApiHomepageToHomeProps = (homepage: ContentfulContentHubHomepage): HomeProps => {
  const { fields } = homepage;
  return {
    hero: fields?.heroBlock?.fields ? homepageToHeroBlockProps(homepage) : undefined,
    theme: fields?.heroTheme ? contentfulApiThemeToContentThemeProps(fields.heroTheme) : undefined,
    sections: fields?.sections
      ?.map(section => section?.fields && contentfulApiSectionToSectionProps(section))
      ?.filter(Boolean) as Array<SectionProps>,
  };
};

const homepageToHeroBlockProps = ({ fields }: ContentfulContentHubHomepage): HeroBlockProps | undefined => {
  if (!fields) return undefined;

  const theme = contentfulApiThemeToContentThemeProps(fields.heroTheme);
  const launchTileHoverPalette = ThemeTransformer.toContentThemePalette(fields.launchTileHoverTheme);
  const heroBlockLogo = fields?.logo?.fields ? AssetTransformer.toImageProps(fields.logo) : null;

  return {
    ...HeroBlockTransformer.toHeroBlockProps(fields.heroBlock, {
      launchTilesProps: fields.launchTiles
        ? {
            tiles: fields.launchTiles?.map(launchTile =>
              LaunchTilesTransformer.toLaunchTileProps(launchTile, { hoverPalette: launchTileHoverPalette })
            ),
          }
        : undefined,
      heroBlockCta: fields.miniBanner?.fields ? <HeroTile {...CardTransformer.toCardProps(fields.miniBanner)} /> : null,
      heroBlockHeadingProps: {
        content: fields.subText,
        color: theme.textColor,
        image: heroBlockLogo?.src ? <img src={heroBlockLogo.src} alt={heroBlockLogo.alt} /> : undefined,
      },
    }),
  };
};
